import { combineReducers } from 'redux';
import auth from './auth/reducers';
import navigation from './navigation/reducers';
import users from './users/reducers';
import codes from './codes/reducers';
import versionControl from './versionControl/reducers';
import messages from './messages/reducers';
import notifications from './pushNotifications/reducers';
import missions from './missions/reducers';

const rootReducer = combineReducers({
  auth,
  navigation,
  users,
  codes,
  versionControl,
  messages,
  notifications,
  missions,
});

export default rootReducer;
